import { useEffect, useState } from "react";

const useAllProduct = () => {
  const [allProduct, setAllProduct] = useState([]);
  useEffect(() => {
    fetch(`https://rocky-ravine-79485.herokuapp.com/all-product`)
      .then((res) => res.json())
      .then((data) => setAllProduct(data));
  }, []);
  return [allProduct, setAllProduct];
};

export default useAllProduct;
